import { render } from "./UpgradeToUnlockNavContainer.vue?vue&type=template&id=2e9f877b&scoped=true"
import script from "./UpgradeToUnlockNavContainer.vue?vue&type=script&lang=js"
export * from "./UpgradeToUnlockNavContainer.vue?vue&type=script&lang=js"

import "./UpgradeToUnlockNavContainer.vue?vue&type=style&index=0&id=2e9f877b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9f877b"],['__file',"src/scripts/common/editorNavBar/UpgradeToUnlockNavContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e9f877b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e9f877b', __exports__)) {
    api.reload('2e9f877b', __exports__)
  }
  
  module.hot.accept("./UpgradeToUnlockNavContainer.vue?vue&type=template&id=2e9f877b&scoped=true", () => {
    api.rerender('2e9f877b', render)
  })

}


export default __exports__